// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  errors: {
    EAN: null,
  },
  search: {
    EAN: null,
  },
  basket: [],
  total: {
    items: 0,
    price: 0,
    orderId: 0,
    redeemValue: 0,
  },
  // The grouped bookshop view of the basket, from GetBookshopBasket. Null for
  // ordinary customers, who never have vouchered lines.
  bookshopBasket: null,
  loading: false,
  voucherCode: '',
  deleteItem: null,
  isEligibleForHomePickup: false,
  basketNotifyError: null,
  disableGetPriceButton: true,
};

const basketReducer = createReducer(initialState, {
  [types.SET_BOOKSHOP_BASKET](state, action) {
    return { ...state, bookshopBasket: action.bookshopBasket };
  },
  // eslint-disable-next-line no-unused-vars
  [types.BASKET_REQUEST](state, action) {
    return {
      ...state,
    };
  },
  [types.BASKET_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      basket: action.basket,
    };
  },
  // ---
  [types.BASKET_SEARCH_REQUEST](state, action) {
    return {
      ...state,
      search: {
        EAN: action.EAN,
      },
    };
  },
  [types.BASKET_SEARCH_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      search: Object.assign({}, state.search, { ...action.data })
    };
  },
  [types.BASKET_SEARCH_REQUEST_FAILED](state, action) {
    return {
      ...state,
      errors: {
        EAN: action.error,
      }
    };
  },
  // ---
  [types.BASKET_SEARCH_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      search: Object.assign({}, state.search, { [payload.field]: payload.value })
    };
  },
  [types.BASKET_SEARCH_ERROR_CHANGE](state, payload) {
    return {
      ...state,
      errors: Object.assign({}, state.errors, { [payload.field]: payload.error })
    };
  },
  // ---
  [types.SET_BASKET_TOTAL](state, action) {
    return {
      ...state,
      total: {
        ...action.total,
      },
    };
  },
  [types.SET_DELETE_ID](state, action) {
    return {
      ...state,
      deleteItem: action.item,
    };
  },
  // ---
  // eslint-disable-next-line no-unused-vars
  [types.BASKET_RESET](state, action) {
    return {
      ...initialState,
    };
  },
  // ---
  [types.LOADING_START](state, action) {
    return {
      ...state,
      loading: action.loading,
    };
  },
  [types.LOADING_STOP](state, action) {
    return {
      ...state,
      loading: action.loading,
    };
  },
  // ---
  [types.SET_VOUCHER_CODE](state, action) {
    return {
      ...state,
      voucherCode: action.code,
    };
  },
  //--
  // eslint-disable-next-line no-unused-vars
  [types.BASKET_REMOVE_ITEM](state, action) {
    return {
      ...state
    };
  },
  [types.GET_IS_ELIGIBLE_FOR_HOME_PICKUP](state) {
    return {
      ...state,
    };
  },
  [types.SET_IS_ELIGIBLE_FOR_HOME_PICKUP](state, action) {
    return {
      ...state,
      isEligibleForHomePickup: action.isEligibleForHomePickup,
    };
  },
  [types.GET_BASKET_NOTIFY_ERROR](state) {
    return {
      ...state,
    };
  },
  [types.SET_BASKET_NOTIFY_ERROR](state, action) {
    return {
      ...state,
      basketNotifyError: action.error,
    };
  },
  [types.SET_DISABLE_GET_PRICE_BUTTON](state, action) {
    return {
      ...state,
      disableGetPriceButton: action.payload,
    };
  }
});

export default basketReducer;
